<template>
  <div id="principaisFornecedoresImpo">
    <loading color="#2185d0" :active.sync="isLoading" loader="bars" :is-full-page="fullPage"></loading>
    <grafico-linha :chart-data="dados_grafico" :options="options"></grafico-linha>
  </div>
</template>
     
<script>
import GraficoLinha from "src/components/graficos/GraficoLinha.vue";

export default {
  name: "PrincipaisFornecedoresImpo",
  props: ["estatisticaInfo"],
  components: {
    GraficoLinha
  },
  data() {
    return {
      isLoading: false,
      fullPage: false,
      dados_grafico: {},
      options: {
        plugins: {
          // Change options for ALL labels of THIS CHART
          datalabels: {
            display: false
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              stacked: true,
              ticks: {
                beginAtZero: true,
                min: 0
              }
            }
          ],
          xAxes: [
            {
              stacked: true,
              ticks: {
                fontSize: 10,
                align: "end"
              }
            }
          ]
        }
      }
    };
  },
  methods: {
    getPrincipaisFornecedoresImpo(data) {
      let url =
        this.$urlApi + "/api/estatisticas-principais-fornecedores-importacao";
      this.isLoading = true;
      this.axios.post(url, data).then(res => {
        //console.log(res.data);
        this.dados_grafico = {
          labels: res.data.label,
          datasets: [
            {
              label: "Principais Fornecedores Importação",
              borderColor: "#6699FF",
              data: res.data.series,
              fill: false
            }
          ]
        };
        this.isLoading = false;
      });
    }
  },
  watch: {
    $props: {
      handler() {
        this.getPrincipaisFornecedoresImpo(this.$props.estatisticaInfo);
      },
      deep: true
    }
  }
};
</script>

<style>
</style>